function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pod_svg__clip0_8847_46528)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.24 9.746a2.107 2.107 0 11-2.093 2.093 2.093 2.093 0 012.093-2.093zM20.24 18.133a2.106 2.106 0 11-2.093 2.107 2.095 2.095 0 012.093-2.107zM11.84 9.746a2.106 2.106 0 11-2.093 2.093 2.093 2.093 0 012.093-2.093zM11.84 18.134a2.108 2.108 0 11.335 4.202 2.108 2.108 0 01-.335-4.202z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.12 26.12a2.15 2.15 0 00.627-1.52V7.4A2.132 2.132 0 0024.6 5.253H7.4A2.147 2.147 0 005.253 7.4V12H2.666V7.4A4.733 4.733 0 017.4 2.667h17.2A4.733 4.733 0 0129.333 7.4v17.2a4.733 4.733 0 01-4.733 4.733H7.466A4.733 4.733 0 012.734 24.6v-3.92h2.6v3.92a2.147 2.147 0 002.133 2.147H24.6a2.146 2.146 0 001.52-.627z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pod_svg__clip0_8847_46528"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(2.667 2.667)",
  d: "M0 0h26.667v26.667H0z"
})));

function SvgPod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPod;